<panel width="650">
	<h1>{{ 'unassigned-qualification-calls.header' | translate }}</h1>
	<blocklist blockListType="qualificationCall" [items]="qualificationCalls" [dragEnabled]="true" (onDrag)="dragging = $event" />
</panel>
<panel width="510">
	<h1>{{ 'unassigned-qualification-calls.users.header' | translate }}</h1>
	<blocklist blockListType="user" [items]="users" [dropEnabled]="true" [dragging]="dragging" (onDrop)="assignQualificationCallToUser($event)" />
</panel>
